import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';
import { ROUTES } from 'shared/constants';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationAnnouncementCreated = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Новое объявление</div>
            <div className={'vm-notification__description'}>
                Добавлено новое объявление <UiNavLink to={ROUTES.ANNOUNCEMENT(notification.data.announcement.id)} onClick={onClose}>{notification.data.announcement.name}</UiNavLink>
            </div>
        </div>
    );
})
